import '@fpsm/cxy-tokens/tokens.css';

import { useRef } from 'react';
import { type MyOCData } from '@cx-web/domain-types/myoc';
import { useUIConfig } from '@cx-web/ui-shell/ui-config-context';
import { removeRepubPrefix } from '@cx-web/utils';

import { type Repub } from '@cx-modules/constants';

import { ArticleLoginWall } from './ArticleLoginWall/ArticleLoginWall';
import { useLoginWall } from './hooks/useLoginWall';
import { handleClick } from './utils/handleClick';
import styles from './InlineHtml.module.css';

export const InlineHtml = ({
  componentTags,
  currentPathWithRepub,
  html,
  myocData,
  repub,
}: {
  componentTags?: string[];
  currentPathWithRepub: string;
  html: string;
  myocData: MyOCData;
  repub: Repub;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { resourcesUrl } = useUIConfig();

  const { shouldRenderLoginWall } = useLoginWall({
    componentTags,
    containerRef,
    isLoggedIn: !!myocData.myOCUser,
  });

  return shouldRenderLoginWall ? (
    <ArticleLoginWall
      currentPath={removeRepubPrefix(currentPathWithRepub, repub)}
      myocData={myocData}
      resourcesUrl={resourcesUrl}
    />
  ) : (
    <div
      className={styles.inlineHtmlWrapper}
      dangerouslySetInnerHTML={{ __html: html }}
      data-testid="inline-html-div"
      onClick={handleClick}
      ref={containerRef}
    />
  );
};
